import Helper from '@ember/component/helper';
import { get } from '@ember/object';
import moment from 'moment';

export default Helper.extend({
  // - args
  //   - fund
  compute(args) {
    let fund = args[0];
    let lastUploadedAt = get(fund, 'lastUploadedAt');
    if (lastUploadedAt == null) {
      return '';
    }

    let days = moment(moment()).diff(lastUploadedAt, 'days');
    if (days === 0) {
      return 'updated today';
    } else if (days === 1) {
      return 'updated yesterday';
    } else {
      return `updated ${days} days ago`;
    }
  },
});
